module.exports = __webpack_public_path__ + "static/media/MeetingRoom.6e3aabd8.jpg";